import { forEach, pickBy } from 'lodash'
import moment from 'moment'

export default {
  methods: {
    _generateDateArray (start, end, step = 'day') {
      let i = 0
      let arr = []
      let length = moment(end).diff(moment(start), `${step}s`)
      while (i <= length) {
        arr.push(moment(end).isoWeekday(1).subtract(i, step).endOf(step).format('YYYYMMDD'))
        i++
      }
      return arr
    },
    _calculateRating (ratings) {
      let prodcutRates = 0; let rates = 0

      forEach(ratings, (cnt, r) => {
        let rating = Number(r.split('_').join('.'))
        cnt = Number(cnt)
        rates += cnt
        prodcutRates += cnt * rating
      })

      return Number((prodcutRates / rates).toFixed(2)) || 0
    },
    _dateIdtoDate (id) {
      let y = id.toString().substr(0, 4)
      let m = id.toString().substr(4, 2)
      let d = id.toString().substr(6, 2)
      return `${y}-${m}-${d}`
    },
    _weekOfMonth (date) {
      date = moment(date)
      let weekInYearIndex = date.isoWeek() + 1
      if (date.year() !== date.weekYear()) {
        weekInYearIndex = date.clone().subtract(1, 'week').week() + 1
      }
      return weekInYearIndex - moment(date).startOf('month').week() + 1
    },
    _chartLabels (start, end, step) {
      let dateArray = this._generateDateArray(start, end, step)
      let labels = []
      let dateFormat = step === 'day'
        ? `DD MMM`
        : `MMM-YYYY`
      let datePrefix = step === 'week'
        ? d => { return `W${this._weekOfMonth(d)} ` }
        : () => { return '' }

      dateArray.forEach(date => { labels.unshift(datePrefix(date) + moment(this._dateIdtoDate(date)).format(dateFormat)) })

      return labels
    },
    _dataToChartData (rawData, start, end, step = 'day') {
      let dateArray = this._generateDateArray(start, end, step)

      return this._dataToTimeChunks(dateArray, rawData, start, end).map(gp => {
        return gp.reduce((tv, id) => Number(tv) + Number(rawData[id]), 0)
      }).reverse()

      // let data = dateArray.map( (v,i) => {
      //   return Object.keys(rawData).filter( k => {
      //     return Number(k) <= Number(i === 0 ? end : v) && Number(k) > Number(dateArray[i + 1] || start)
      //   }).reduce( (tv, id) => {
      //     return Number(tv) + Number(rawData[id])
      //   }, 0)
      // }).reverse()

      // return data
    },
    _analyseVisits (data, fpMap) {
      let { mEnd, lmStart } = this._monthDates()
      let filtered = pickBy(data, (v, k) => Number(k) >= lmStart && Number(k) <= mEnd)
      let visitors = {}

      forEach(filtered, (visits, dateId) => {
        let dateVisits = {}
        forEach(visits, (v, k) => {
          if (fpMap[k]) { dateVisits[fpMap[k][0]] = (dateVisits[fpMap[k][0]] || 0) + v } else { dateVisits[k] = (dateVisits[k] || 0) + v }
        })
        visitors[dateId] = Object.keys(dateVisits).length
      })
      return this._monthComparison(visitors)
    },
    _dataToTimeChunks (dateArray, rawData, start, end) {
      return dateArray
        .map((v, i) => {
          return Object.keys(rawData)
            .filter(k => {
              return Number(k) <= Number(i === 0 ? end : v) && Number(k) > Number(dateArray[i + 1] || start)
            })
        })
    },
    _sumData (rawData, start, end) {
      let data = Object.keys(rawData).filter(k => Number(k) >= start && Number(k) <= end).reduce((t, id) => { return t = Number(t) + Number(rawData[id]) }, 0)
      return data
    },
    _monthDates () {
      let year = moment().year()
      let month = moment().month()
      let day = moment().date()
      let mdays = moment().daysInMonth()
      let lmdays = moment().subtract(1, 'month').daysInMonth()
      let lyear = month > 0 ? year : year - 1
      let mStart = Number(moment(`${year}-${month + 1}-01`, 'YYYY-MM-DD').format('YYYYMMDD'))
      let mCrnt = Number(moment().format('YYYYMMDD'))
      let mEnd = Number(moment(`${year}-${month + 1}-${mdays}`, 'YYYY-MM-DD').format('YYYYMMDD'))
      let lmStart = Number(moment(`${lyear}-${month}-01`, 'YYYY-MM-DD').format('YYYYMMDD'))
      let lmCrnt = Number(moment(`${lyear}-${month}-${day}`, 'YYYY-MM-DD').format('YYYYMMDD'))
      let lmEnd = Number(moment(`${lyear}-${month}-${lmdays}`, 'YYYY-MM-DD').format('YYYYMMDD'))
      return {
        mStart: mStart,
        mCrnt: mCrnt,
        mEnd: mEnd,
        lmStart: lmStart,
        lmCrnt: lmCrnt,
        lmEnd: lmEnd
      }
    },
    _monthComparison (data, accumulator) {
      let { mtd, mtdLast, mLast } = accumulator || { mtd: 0, mtdLast: 0, mLast: 0 }
      let { mStart, mCrnt, lmStart, lmCrnt, lmEnd } = this._monthDates()

      mtd += this._sumData(data, mStart, mCrnt) || 0
      mtdLast += this._sumData(data, lmStart, lmCrnt) || 0
      mLast += this._sumData(data, lmStart, lmEnd) || 0

      return {
        mtd: mtd,
        mtdLast: mtdLast,
        mLast: mLast,
        mtdPercent: isFinite((mtd - mtdLast) / mtdLast) ? ((mtd - mtdLast) / mtdLast * 100).toFixed(0) : 100,
        mLastPercent: isFinite((mtd - mLast) / mLast) ? ((mtd - mLast) / mLast * 100).toFixed(0) : 100,
        mtdGrow: (mtd - mtdLast) > 0,
        mLastGrow: (mtd - mLast) > 0
      }
    }
  }
}
